export const partiesInfo=(isImportShipment)=>({
    consignor:{title:isImportShipment?"consignor/vendor":"Ship From",tableName:"consignorsList",boxNumber:isImportShipment ? "3/7" :""},
    consignee:{title:"consignee",tableName:"consigneeList",boxNumber:"3/9"},
    representative:{title:isImportShipment ? "representative/agent" : "representative",tableName:"representativesList",boxNumber:"3/19"  },
    declarant:{title:"declarant",tableName:"declarantsList",boxNumber:"3/17"},
    importer:{title:"importer",tableName:"importersList",boxNumber:"3/15"},
    exporter:{title:"exporter",tableName:"exportersList",boxNumber:"3/1"},
    forwarder:{title:"forwarder",tableName:"forwardersList"},
    location:{title:isImportShipment?"shipfrom":"location/4pl",tableName:"location4plsList"},
    buyer:{title:"buyer",tableName:"buyersList",boxNumber:"3/26"},
    seller:{title:"seller",tableName:"sellersList",boxNumber:"3/24"},
    surety:{title:"surety",tableName:"suritiesList",boxNumber:"3/26"},
    carrier:{title:"carrier",tableName:"carriersList",boxNumber:"3/31"},
    'representative/agent':{title:"representative/agent",tableName:"representativesList",boxNumber:"3/19"},
    'location/4pl':{title:"location/4pl",tableName:"location4plsList",boxNumber:""},
    'economic operator':{title:"economic operator",tableName:"economicOperatorsList",boxNumber:""},
    // 'ship from':{title:"ship from",tableName:"shipfromList",boxNumber:""}
})